import { useState, useEffect, useCallback } from 'react';
import { kpiApi } from '../../services/kpiApi';

export function useKpiList(orgId = 'default') {
  const [kpis, setKpis] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await kpiApi.listKpis(orgId);
      setKpis(data);
    } catch { /* ignore */ }
    setLoading(false);
  }, [orgId]);

  useEffect(() => { refresh(); }, [refresh]);

  // ItemSidebar needs { id, name } at minimum
  const items = kpis.map(k => ({
    id: k.id,
    name: k.name,
    source_type: k.source_type,
    format: k.format,
    description: k.description,
    tags: k.tags,
    scope: k.scope,
  }));

  const kpiMap = new Map(kpis.map(k => [k.id, k]));

  return { items, kpiMap, refresh, loading };
}
